const OrderMode = {
  ON_SITE: 0,
  TAKE_AWAY: 1,
  DELIVERY: 2,
}

export default OrderMode
